import { useEffect, useRef, useState } from "react";
import { bannerService } from "../services/BannerService";
import { Banner } from "../interfaces/Banner";

// =====================================================
// TOAST MODAL
// =====================================================
function ToastModal({
  message, type, onClose,
}: { message: string; type: "success" | "error" | "info"; onClose: () => void; }) {
  const icon = type === "success" ? "✅" : type === "error" ? "❌" : "ℹ️";
  const color = type === "success" ? "#166534" : type === "error" ? "#991b1b" : "#1e3a5f";
  const bg = type === "success" ? "#dcfce7" : type === "error" ? "#fee2e2" : "#dbeafe";
  return (
    <div className="pm-del-overlay" style={{ zIndex: 99999 }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="pm-del-box" style={{ maxWidth: 380 }}>
        <div className="pm-del-ico" style={{ background: bg }}>
          <span style={{ fontSize: 24 }}>{icon}</span>
        </div>
        <div className="pm-del-title" style={{ color }}>{message}</div>
        <div className="pm-del-btns" style={{ marginTop: 22 }}>
          <button className="pm-btn-save" onClick={onClose} type="button" style={{ minWidth: 100 }}>OK</button>
        </div>
      </div>
    </div>
  );
}




// const initialBanners: Banner[] = [
//   { id: "b1", title: "Bridal Collection 2025", subtitle: "Up to 30% off on all bridal sets", imageUrl: "https://placehold.co/800x300/fde68a/92400e?text=Bridal+Banner", link: "/bridal", position: "hero", status: "active", order: 1, startDate: "2025-04-01", endDate: "2025-05-31" },
//   { id: "b2", title: "Festive Offers", subtitle: "Dhamaka deals this season", imageUrl: "https://placehold.co/800x300/ddd6fe/4c1d95?text=Festive+Banner", link: "/offers", position: "hero", status: "active", order: 2, startDate: "2025-04-15", endDate: "2025-05-15" },
//   { id: "b3", title: "Free Shipping", subtitle: "On orders above ₹999", imageUrl: "https://placehold.co/400x400/d1fae5/065f46?text=Strip", link: "/shipping", position: "strip", status: "active", order: 1, startDate: "2025-01-01", endDate: "2025-12-31" },
// ];

const positionColors: Record<Banner["position"], string> = {
  hero: "var(--theme)",
  sidebar: "#f59e0b",
  popup: "#ec4899",
  strip: "#10b981",
};

type ModalMode = "none" | "add" | "edit";
// const emptyBanner = (): Omit<Banner, "id"> => ({
//   title: "", subtitle: "", imageUrl: "", link: "", position: "hero",
//   status: "active", order: 1, startDate: "", endDate: "",
// });

const emptyBanner = () => ({
  title: "",
  subtitle: "",
  imageUrl: "",
  timageUrl: "",

  // ✅ NEW FIELDS
  titleEm: "",
  tag: "",
  thumbnailLabel: "",
  thumbnailImage: null as File | null,

  link: "",
  position: "hero" as "hero" | "sidebar" | "popup" | "strip",
  status: "active" as "active" | "inactive",
  order: 1,
  startDate: "",
  endDate: "",

  bannerImage: null as File | null
});

export function BannersPage() {
  // const [banners, setBanners] = useState<Banner[]>(initialBanners);
  const [banners, setBanners] = useState<Banner[]>([]);
  const [modalMode, setModalMode] = useState<ModalMode>("none");
  const [selected, setSelected] = useState<Banner | null>(null);
  const [form, setForm] = useState(emptyBanner());
  const imageFileRef = useRef<HTMLInputElement>(null);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [toast, setToast] = useState<{ message: string; type: "success" | "error" | "info" } | null>(null);

  function showToast(message: string, type: "success" | "error" | "info" = "success") {
    setToast({ message, type });
  }

  const timageFileRef = useRef<HTMLInputElement>(null);
  const API_PATH =
    process.env.REACT_APP_API_PATH;

  async function loadBanners() {
    try {
      const data = await bannerService.getAll();

      console.log(data,"Load Banners")

     const mapped = data.map((b: any) => ({
  ...b,
  status: b.bannerStatus ? "active" : "inactive",
}));

      setBanners(mapped);
    } catch (error) {
      console.error("Failed to load banners", error);
    }
  }

  useEffect(() => {

    loadBanners();

  }, []);

  function openAdd() { setForm(emptyBanner()); setModalMode("add"); }
  function openEdit(
    b: Banner
  ) {
    debugger
    setForm({


      title:
        b.bannerTitle,

      subtitle:
        b.bannerSubTitle,

      imageUrl: b.bannerImage
        ? `${API_PATH}/uploads/${b.bannerImage}`
        : "",

      timageUrl: b.thumbnailImage
        ? `${API_PATH}/uploads/${b.thumbnailImage}`
        : "",
      titleEm: b.titleEm,
      tag: b.tag,
      thumbnailLabel: b.thumbnailLabel,
      thumbnailImage: null,

      link: (b as any).buttonLink || (b as any).link || "",

      order: (b as any).displayOrder || (b as any).order || 1,

      position:
        b.position,


      status: b.bannerStatus ? "active" : "inactive",




      startDate: b.startDate ? b.startDate.split("T")[0] : "",
      endDate: b.endDate ? b.endDate.split("T")[0] : "",

      bannerImage:
        null
    });

    setSelected(b);

    setModalMode("edit");
  }
  function confirmDelete(bannerID: number) {
    setDeleteId(bannerID);
    setShowDeleteModal(true);
  }

  async function handleDelete() {
    if (!deleteId) return;

    try {
      await bannerService.delete(deleteId);

      setBanners(prev =>
        prev.filter(b => b.bannerID !== deleteId)
      );

      showToast("Banner deleted successfully", "success");

      setShowDeleteModal(false);
      setDeleteId(null);

    } catch (error) {
      console.error(error);
      showToast("Failed to delete banner", "error");
    }
  }
  function closeModal() { setModalMode("none"); setSelected(null); if (imageFileRef.current) imageFileRef.current.value = ""; }

  async function save() {

    if (!form.title) return;

    try {

      if (modalMode === "add") {

        await bannerService.create({
          title: form.title,
          subtitle: form.subtitle,
          link: form.link,
          position: form.position,
          status: form.status,
          order: form.order,
          startDate: form.startDate,
          endDate: form.endDate,
          bannerImage: form.bannerImage,
          thumbnailImage: form.thumbnailImage,
          titleEm: form.titleEm,
          thumbnailLabel: form.thumbnailLabel,
          tag: form.tag
        });

        showToast("Banner created successfully", "success");

      }
      else if (selected) {

        const formData = new FormData();

        formData.append("bannerID", selected.bannerID.toString());
        formData.append("title", form.title);
        formData.append("subtitle", form.subtitle);
        formData.append("link", form.link);
        formData.append("position", form.position);
        formData.append("status", form.status);
        formData.append("order", form.order.toString());
        formData.append("startDate", form.startDate);
        formData.append("endDate", form.endDate);

        // NEW FIELDS
        formData.append("titleEm", form.titleEm);
        formData.append("tag", form.tag);
        formData.append("thumbnailLabel", form.thumbnailLabel);

        // FILES (ONLY IF SELECTED)
        if (form.bannerImage instanceof File) {
          formData.append("bannerImage", form.bannerImage);
        }

        if (form.thumbnailImage instanceof File) {
          formData.append("thumbnailImage", form.thumbnailImage);
        }

        await bannerService.update(formData);
        showToast("Banner updated successfully", "success");
      }

      await loadBanners();

      closeModal();

    } catch (error) {

      console.error(error);
    }
  }

  async function toggleStatus(bannerID: number, currentStatus: "active" | "inactive") {
    const newStatus = currentStatus === "active" ? "inactive" : "active";

    try {
      await bannerService.updateStatus({
        bannerID,
        status: newStatus,
      });

      setBanners(prev =>
        prev.map(b =>
          b.bannerID === bannerID
            ? { ...b, status: newStatus }
            : b
        )
      );

       // ✅ Toast notification
    showToast("Banner status updated successfully", "success");
  } catch (error) {
    console.error(error);
    showToast("Failed to update status", "error");
  }

    
  }

  const formatDate = (date?: string) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-GB");
  };

  function deleteBanner(bannerID: number) {

    setBanners(prev =>
      prev.filter(b => b.bannerID !== bannerID)
    );
  }
  function f<K extends keyof typeof form>(k: K, v: typeof form[K]) { setForm(prev => ({ ...prev, [k]: v })); }

  function handleImageFile(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;

    f("bannerImage", file);

    const reader = new FileReader();
    reader.onload = (ev) => {
      f("imageUrl", ev.target?.result as string);
    };
    reader.readAsDataURL(file);
  }
  function handleThumbnailImageFile(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file) return;

    f("thumbnailImage", file); // ✅ FIXED

    const reader = new FileReader();
    reader.onload = (ev) => {
      f("timageUrl", ev.target?.result as string);
    };

    reader.readAsDataURL(file);
  }

  return (
    <>
      <style>{`
        .bn-topbar { display:flex; justify-content:space-between; align-items:center; margin-bottom:20px; flex-wrap:wrap; gap:12px; }
        .bn-btn-primary { background:linear-gradient(135deg,#ec4899,#8b5cf6); color:#fff; border:none; border-radius:10px; padding:9px 20px; font-size:14px; font-weight:600; cursor:pointer; display:flex; align-items:center; gap:7px; box-shadow:0 2px 8px rgba(139,92,246,.35); }
        .bn-card { background:#fff; border-radius:14px; border:1px solid #f1f5f9; box-shadow:0 2px 8px rgba(0,0,0,.06); overflow:hidden; margin-bottom:14px; }
        .bn-card-img { width:100%; height:120px; object-fit:cover; background:#f8fafc; display:flex; align-items:center; justify-content:center; color:#cbd5e1; font-size:32px; }
        .bn-card-body { padding:14px 16px; }
        .bn-pos-badge { display:inline-block; padding:3px 10px; border-radius:20px; font-size:11px; font-weight:700; color:#fff; margin-bottom:8px; }
        .bn-card-title { font-size:15px; font-weight:700; color:#1e293b; }
        .bn-card-sub { font-size:13px; color:#64748b; margin:2px 0 8px; }
        .bn-card-meta { font-size:11px; color:#94a3b8; }
        .bn-card-footer { display:flex; gap:8px; padding:10px 16px; border-top:1px solid #f8fafc; background:#fafbff; align-items:center; justify-content:space-between; }
        .bn-toggle { position:relative; width:40px; height:22px; }
        .bn-toggle input { opacity:0; width:0; height:0; }
        .bn-slider { position:absolute; cursor:pointer; inset:0; background:#e2e8f0; border-radius:22px; transition:.3s; }
        .bn-slider:before { content:''; position:absolute; width:16px; height:16px; left:3px; bottom:3px; background:#fff; border-radius:50%; transition:.3s; }
        input:checked + .bn-slider { background:#10b981; }
        input:checked + .bn-slider:before { transform:translateX(18px); }
        .bn-btn-sm { padding:5px 12px; border-radius:8px; border:1.5px solid #e2e8f0; background:#fff; font-size:12px; font-weight:600; cursor:pointer; color:#475569; transition:all .15s; }
        .bn-btn-sm:hover { border-color:var(--theme); color:var(--theme); }
        .bn-btn-del { border-color:#fee2e2; color:#ef4444; }
        .bn-btn-del:hover { background:#fee2e2; }
        .bn-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(280px,1fr)); gap:16px; }
        .ns-overlay { position:fixed; inset:0; background:rgba(15,23,42,.55); backdrop-filter:blur(4px); z-index:1000; display:flex; align-items:flex-start; justify-content:center; padding:24px 16px; overflow-y:auto; }
        .ns-modal { background:#fff; border-radius:20px; width:100%; max-width:600px; box-shadow:0 24px 60px rgba(0,0,0,.2); margin:auto; animation:mIn .25s ease; }
        @keyframes mIn { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:none} }
        .ns-modal-head { display:flex; align-items:center; justify-content:space-between; padding:20px 24px; border-bottom:1px solid #f1f5f9; }
        .ns-modal-title { font-size:17px; font-weight:700; color:#1e293b; }
        .ns-modal-close { width:34px; height:34px; border-radius:9px; border:1.5px solid #e2e8f0; background:#fff; cursor:pointer; font-size:16px; color:#64748b; }
        .ns-modal-body { padding:22px 24px; max-height:70vh; overflow-y:auto; }
        .ns-modal-foot { padding:16px 24px; border-top:1px solid #f1f5f9; display:flex; justify-content:flex-end; gap:10px; }
        .ns-field2 { margin-bottom:14px; }
        .ns-label2 { font-size:12px; font-weight:700; color:#64748b; text-transform:uppercase; letter-spacing:.5px; display:block; margin-bottom:5px; }
        .ns-input2 { width:100%; padding:9px 12px; border:1.5px solid #e2e8f0; border-radius:10px; font-size:14px; outline:none; box-sizing:border-box; }
        .ns-input2:focus { border-color:#ec4899; box-shadow:0 0 0 3px rgba(236,72,153,.1); }
        .ns-row2 { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
        .ns-btn-sec { background:#f8fafc; color:#475569; border:1.5px solid #e2e8f0; border-radius:10px; padding:9px 16px; font-size:13px; font-weight:600; cursor:pointer; }
        .ns-btn-pink { background:linear-gradient(135deg,#ec4899,#8b5cf6); color:#fff; border:none; border-radius:10px; padding:9px 20px; font-size:14px; font-weight:600; cursor:pointer; }

        /* Image upload styles */
        .bn-img-upload-box { border:2px dashed #e2e8f0; border-radius:12px; overflow:hidden; background:#f8fafc; }
        .bn-img-preview-wrap { position:relative; }
        .bn-img-preview-wrap img { width:100%; height:160px; object-fit:cover; display:block; }
        .bn-img-preview-overlay { position:absolute; inset:0; background:rgba(0,0,0,.45); opacity:0; transition:.2s; display:flex; align-items:center; justify-content:center; gap:10px; }
        .bn-img-preview-wrap:hover .bn-img-preview-overlay { opacity:1; }
        .bn-img-overlay-btn { background:rgba(255,255,255,.92); border:none; border-radius:8px; padding:6px 14px; font-size:12px; font-weight:700; cursor:pointer; color:#1e293b; display:flex; align-items:center; gap:5px; }
        .bn-img-overlay-btn.del { color:#ef4444; }
        .bn-img-empty { height:120px; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:8px; color:#94a3b8; cursor:pointer; transition:background .15s; }
        .bn-img-empty:hover { background:#f1f5f9; }
        .bn-img-empty-icon { font-size:28px; }
        .bn-img-empty-text { font-size:12px; font-weight:600; }
        .bn-img-url-row { display:flex; gap:8px; align-items:center; padding:10px 12px; border-top:1px solid #f1f5f9; background:#fff; }
        .bn-img-url-row input { flex:1; padding:7px 10px; border:1.5px solid #e2e8f0; border-radius:8px; font-size:13px; outline:none; }
        .bn-img-url-row input:focus { border-color:#ec4899; }
        .bn-img-upload-btn { background:linear-gradient(135deg,#ec4899,#8b5cf6); color:#fff; border:none; border-radius:8px; padding:7px 14px; font-size:12px; font-weight:700; cursor:pointer; white-space:nowrap; display:flex; align-items:center; gap:5px; flex-shrink:0; }
      `}</style>
      <div>
        <div className="bn-topbar">
          <div className="bn-info-text">{banners.length} banners · {banners.filter(b => b.status === "active").length} active</div>
          <button className="bn-btn-primary" onClick={openAdd} type="button">+ Add Banner</button>
        </div>
        <div className="bn-grid">
          {banners.map(b => (
            <div key={b.bannerID} className="bn-card">
              {b.bannerImage ? (
                <img src={`${API_PATH}/uploads/${b.bannerImage}`} alt={b.bannerTitle} className="bn-card-img" />
              ) : (
                <div className="bn-card-img">🖼️</div>
              )}
              <div className="bn-card-body">
                <div className="bn-pos-badge" style={{ background: positionColors[b.position] }}>{b.position}</div>
                <div className="bn-card-title">{b.bannerTitle}</div>
                <div className="bn-card-sub">{b.bannerSubTitle}</div>
                <div className="bn-card-meta">📅 {formatDate(b.startDate)} → {formatDate(b.endDate)} · Order #{b.order}</div>
              </div>
              <div className="bn-card-footer">
                <label className="bn-toggle">
                  <input
                    type="checkbox"
                    checked={b.status === "active"}
                    onChange={() => toggleStatus(b.bannerID, b.status)}
                  />
                  <span className="bn-slider"></span>
                </label>
                <div className="ns-flex-gap6">
                  <button className="bn-btn-sm" onClick={() => openEdit(b)} type="button">Edit</button>
                  <button className="bn-btn-sm bn-btn-del" onClick={() => confirmDelete(b.bannerID)} type="button">Delete</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {(modalMode === "add" || modalMode === "edit") && (
        <div className="ns-overlay" onClick={e => { if (e.target === e.currentTarget) closeModal(); }}>
          <div className="ns-modal">
            <div className="ns-modal-head">
              <span className="ns-modal-title">{modalMode === "add" ? "Add Banner" : "Edit Banner"}</span>
              <button className="ns-modal-close" onClick={closeModal} type="button">✕</button>
            </div>
            <div className="ns-modal-body">
              <div className="ns-field2"><label className="ns-label2">Title *</label><input className="ns-input2" value={form.title} onChange={e => f("title", e.target.value)} placeholder="Banner title" /></div>
              <div className="ns-field2"><label className="ns-label2">Subtitle</label><input className="ns-input2" value={form.subtitle} onChange={e => f("subtitle", e.target.value)} placeholder="Short description" /></div>
              <div className="ns-field2">
                <label className="ns-label2">Title Em</label>
                <input
                  className="ns-input2"
                  value={form.titleEm}
                  onChange={e => f("titleEm", e.target.value)}
                  placeholder="Emphasized title"
                />
              </div>
              <div className="ns-field2">
                <label className="ns-label2">Tag</label>
                <input
                  className="ns-input2"
                  value={form.tag}
                  onChange={e => f("tag", e.target.value)}
                  placeholder="e.g. NEW, HOT, SALE"
                />
              </div>
              <div className="ns-field2">
                <label className="ns-label2">Thumbnail Label</label>
                <input
                  className="ns-input2"
                  value={form.thumbnailLabel}
                  onChange={e => f("thumbnailLabel", e.target.value)}
                  placeholder="Small label under thumbnail"
                />
              </div>
              {/* ── Image Upload ── */}
              <div className="ns-field2">
                <label className="ns-label2">Banner Image</label>
                <div className="bn-img-upload-box">
                  {form.imageUrl ? (
                    <div className="bn-img-preview-wrap">
                      <img src={form.imageUrl} alt="Preview" />
                      <div className="bn-img-preview-overlay">
                        <button type="button" className="bn-img-overlay-btn"
                          onClick={() => imageFileRef.current?.click()}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
                          Change
                        </button>
                        <button type="button" className="bn-img-overlay-btn del"
                          onClick={() => { f("imageUrl", ""); if (imageFileRef.current) imageFileRef.current.value = ""; }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /></svg>
                          Remove
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="bn-img-empty" onClick={() => imageFileRef.current?.click()}>
                      <div className="bn-img-empty-icon">🖼️</div>
                      <div className="bn-img-empty-text">Click to upload image</div>
                      <small style={{ color: "#cbd5e1", fontSize: 11 }}>PNG, JPG, WebP supported</small>
                    </div>
                  )}
                  <div className="bn-img-url-row">
                    <button type="button" className="bn-img-upload-btn"
                      onClick={() => imageFileRef.current?.click()}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
                      Upload
                    </button>
                    <input
                      placeholder="or paste image URL..."
                      value={form.imageUrl.startsWith("data:") ? "" : form.imageUrl}
                      onChange={e => f("imageUrl", e.target.value)}
                    />
                  </div>
                </div>
                <input ref={imageFileRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleImageFile} />
              </div>

              {/* ── Image Upload ── */}
              <div className="ns-field2">
                <label className="ns-label2">Thumbnail Image</label>
                <div className="bn-img-upload-box">
                  {form.timageUrl ? (
                    <div className="bn-img-preview-wrap">
                      <img src={form.timageUrl} alt="Preview" />
                      <div className="bn-img-preview-overlay">
                        <button type="button" className="bn-img-overlay-btn"
                          onClick={() => timageFileRef.current?.click()}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
                          Change
                        </button>
                        <button type="button" className="bn-img-overlay-btn del"
                          onClick={() => { f("timageUrl", ""); if (timageFileRef.current) timageFileRef.current.value = ""; }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /></svg>
                          Remove
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="bn-img-empty" onClick={() => timageFileRef.current?.click()}>
                      <div className="bn-img-empty-icon">🖼️</div>
                      <div className="bn-img-empty-text">Click to upload image</div>
                      <small style={{ color: "#cbd5e1", fontSize: 11 }}>PNG, JPG, WebP supported</small>
                    </div>
                  )}
                  <div className="bn-img-url-row">
                    <button type="button" className="bn-img-upload-btn"
                      onClick={() => timageFileRef.current?.click()}>
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
                      Upload
                    </button>
                    <input
                      placeholder="or paste image URL..."
                      value={form.timageUrl.startsWith("data:") ? "" : form.timageUrl}
                      onChange={e => f("timageUrl", e.target.value)}
                    />
                  </div>
                </div>
                <input ref={timageFileRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleThumbnailImageFile} />
              </div>

              <div className="ns-field2"><label className="ns-label2">Link</label><input className="ns-input2" value={form.link} onChange={e => f("link", e.target.value)} placeholder="/page-slug" /></div>
              <div className="ns-row2">
                <div className="ns-field2">
                  <label className="ns-label2">Position</label>
                  <select className="ns-input2" value={form.position} onChange={e => f("position", e.target.value as Banner["position"])}>
                    {["hero", "sidebar", "popup", "strip"].map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <div className="ns-field2">
                  <label className="ns-label2">Status</label>
                  <select className="ns-input2" value={form.status} onChange={e => f("status", e.target.value as Banner["status"])}>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </div>
              <div className="ns-row2">
                <div className="ns-field2"><label className="ns-label2">Start Date</label><input className="ns-input2" type="date" value={form.startDate} onChange={e => f("startDate", e.target.value)} /></div>
                <div className="ns-field2"><label className="ns-label2">End Date</label><input className="ns-input2" type="date" value={form.endDate} onChange={e => f("endDate", e.target.value)} /></div>
              </div>
              <div className="ns-field2"><label className="ns-label2">Display Order</label><input className="ns-input2" type="number" value={form.order} onChange={e => f("order", Number(e.target.value))} /></div>
            </div>
            <div className="ns-modal-foot">
              <button className="ns-btn-sec" onClick={closeModal} type="button">Cancel</button>
              <button className="ns-btn-pink" onClick={save} type="button">{modalMode === "add" ? "Add Banner" : "Save Changes"}</button>
            </div>
          </div>
        </div>
      )}
      {showDeleteModal && (
        <div className="ns-overlay" onClick={e => {
          if (e.target === e.currentTarget) {
            setShowDeleteModal(false);
          }
        }}>
          <div className="ns-modal" style={{ maxWidth: "420px" }}>
            <div className="ns-modal-head">
              <span className="ns-modal-title">Delete Banner</span>
              <button className="ns-modal-close" onClick={() => setShowDeleteModal(false)}>✕</button>
            </div>

            <div className="ns-modal-body">
              <p style={{ margin: 0, color: "#64748b" }}>
                Are you sure you want to delete this banner? This action cannot be undone.
              </p>
            </div>

            <div className="ns-modal-foot">
              <button className="ns-btn-sec" onClick={() => setShowDeleteModal(false)}>
                Cancel
              </button>

              <button className="ns-btn-pink" onClick={handleDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {toast && (
        <ToastModal
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </>
  );
}
